import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { appName } from "../../../app.json";
import ActivePage from "../../../partials/active-page";
import NewLeaveStatusForm from "./NewLeaveStatus";
import {
	GET_LEAVE_STATUS,
	NEW_LEAVE_STATUS,
	UPDATE_LEAVE_STATUS
} from "../../../queries/leave-status.query";
import { useQuery, useMutation } from "@apollo/react-hooks";
import AlertMessage from "../../../partials/alertMessage";
import LoadingSpinner from "../../../partials/loading";
import LeaveStatusList from "./LeaveStatusList";
import auth from "../../../providers/Auth.Provider";
import UpdateLeaveStatus from "./UpdateLeaveStatus";

const LeaveStatus = ({ match }) => {
	// local state
	const [newLeaveStatus, setNewLeaveStatus] = useState(false);
	const [leave_status, setLeaveStatus] = useState(null);
	// site
	const { GetToken, GetAuthenticatedStaff } = auth.authProvider;
	const { site } = GetToken() && GetAuthenticatedStaff();

	// prepare query
	const { loading: gLoading, data: gData, error: gError } = useQuery(
		GET_LEAVE_STATUS,
		{ variables: { site: site && site.id } }
	);

	// prepare mutation
	const [
		NewLeaveStatus,
		{ loading: nLoading, data: nData, error: nError }
	] = useMutation(NEW_LEAVE_STATUS, {
		update(
			caches,
			{
				data: { NewLeaveStatus }
			}
		) {
			const { GetLeaveStatusList } = caches.readQuery({
				query: GET_LEAVE_STATUS,
				variables: { site: site && site.id }
			});
			// update
			GetLeaveStatusList.docs.unshift(NewLeaveStatus.doc);
			// write back
			caches.writeQuery({
				data: { GetLeaveStatusList },
				variables: { site: site && site.id },
				query: GET_LEAVE_STATUS
			});
		}
	});

	// prepare Update mutation
	const [
		UpdateLeaveStatusFunc,
		{ loading: uLoading, data: uData, error: uError }
	] = useMutation(UPDATE_LEAVE_STATUS);
	// props
	const title = "Staff Leave Status";
	const pages = [
		{
			title: "Application Management",
			path: "/home/app-management"
		},
		{ title, path: match.path }
	];

	return (
		<>
			<Helmet>
				<title>
					{title} | {appName}
				</title>
			</Helmet>
			<ActivePage pages={pages} title={title} />

			<div className="row justify-content-center">
				{newLeaveStatus && (
					<div className="col-md-8 col-sm-12 fade-in">
						<div className="card">
							<div className="card-head">
								<header>New Leave Status</header>
							</div>
							<div className="card-body m-b-20">
								<LoadingSpinner loading={nLoading} />
								<AlertMessage
									message={nError && nError.message}
									failed={true}
								/>
								<AlertMessage
									message={nData && nData.NewLeaveStatus.message}
									failed={false}
								/>
								<NewLeaveStatusForm
									onCancel={() => setNewLeaveStatus(false)}
									onSubmit={async name => {
										await NewLeaveStatus({
											variables: { site: site && site.id, name }
										});
									}}
								/>
							</div>
						</div>
					</div>
				)}
				{leave_status && (
					<div className="col-md-8 col-sm-12 fade-in">
						<div className="card">
							<div className="card-head">
								<header>Update Leave Status</header>
							</div>
							<div className="card-body m-b-20">
								<LoadingSpinner loading={uLoading} />
								<AlertMessage
									message={uError && uError.message}
									failed={true}
								/>
								<AlertMessage
									message={uData && uData.UpdateLeaveStatus.message}
									failed={false}
								/>
								<h5>{leave_status.name}: </h5>
								<UpdateLeaveStatus
									onCancel={() => {
										setLeaveStatus(null);
										setNewLeaveStatus(false);
									}}
									onSubmit={async name => {
										await UpdateLeaveStatusFunc({
											variables: { id: leave_status.id, name }
										});
										setLeaveStatus(null);
									}}
									currentValue={leave_status.name}
								/>
							</div>
						</div>
					</div>
				)}
				<div className="col-md-8 col-sm-12">
					<div className="card">
						<div className="card-head">
							<header>Leave Status</header>
							<div className="tools">
								<button
									title="Add LeaveStatus"
									onClick={() => {
										setNewLeaveStatus(true);
										setLeaveStatus(null);
									}}
									className="mdl-button mdl-button--icon margin-right-10 btn-success"
								>
									<i className="material-icons">add</i>
								</button>
							</div>
						</div>
						<div className="card-body">
							<LoadingSpinner loading={gLoading} />
							<AlertMessage message={gError && gError.message} failed={true} />
							{!gLoading && (
								<LeaveStatusList
									items={gData && gData.GetLeaveStatusList.docs}
									onEdit={item => {
										setLeaveStatus(item);
										setNewLeaveStatus(false);
										document.body.scrollTop = 0;
										document.documentElement.scrollTop = 0;
									}}
								/>
							)}
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default LeaveStatus;
